module.exports = __webpack_public_path__ + "img/1-1.a39f9ebf.svg";